var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -9,
    y: -9,
    width: 90,
    height: 90
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.5px)",
      clipPath: "url(#bgblur_0_782_2696_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left Arrow",
    "data-figma-bg-blur-radius": 9
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "var(--fill-0, black)",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M28.5 48.263V23.737C28.5 22.1396 30.2803 21.1869 31.6094 22.0729L50.0039 34.3359C51.1913 35.1275 51.1913 36.8725 50.0038 37.6641L31.6094 49.9271C30.2803 50.8131 28.5 49.8604 28.5 48.263Z",
    fill: "var(--fill-0, #FAFAFA)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_782_2696_clip_path",
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow_circle.89f4205066c3fc78b262857333377dac.svg";
export { ForwardRef as ReactComponent };